(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yof-project-popup"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('YofProjectPopup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'yof-project-prompt-v1';
  let seen = true;
  try { seen = sessionStorage.getItem(key) === 'seen'; } catch (_) { return; }
  if (seen) return;
  const dismiss = () => dialog.close();
  dialog.querySelector('.yof-project-popup-close').addEventListener('click', dismiss);
  dialog.querySelector('.yof-project-popup-dismiss').addEventListener('click', dismiss);
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dismiss(); } });
  setTimeout(() => {
    if (document.visibilityState !== 'visible' || document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open],cart-drawer.active')) return;
    try { if (sessionStorage.getItem('yof-invitation-shown')) return; sessionStorage.setItem(key, 'seen'); sessionStorage.setItem('yof-invitation-shown', 'project'); } catch (_) { return; }
    dialog.showModal();
  }, 45000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yof-return-invitation"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('YofReturnInvitation');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'yof-return-invitation-v1';
  try { if (localStorage.getItem(key) === 'subscribed') return; } catch (_) { return; }
  const began = Date.now();
  const close = () => dialog.close();
  dialog.querySelector('[data-return-close]').addEventListener('click', close);
  dialog.querySelector('[data-return-dismiss]').addEventListener('click', close);
  if (dialog.querySelector('[data-return-success]')) {
    try { localStorage.setItem(key, 'subscribed'); } catch (_) {}
    dialog.showModal();
    return;
  }
  if (dialog.querySelector('[data-return-errors]')) {
    dialog.showModal();
    return;
  }
  const invite = () => {
    if (Date.now() - began < 20000 || document.visibilityState !== 'visible' || document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open],cart-drawer.active')) return;
    try { if (sessionStorage.getItem('yof-invitation-shown')) return; sessionStorage.setItem('yof-invitation-shown', 'return'); } catch (_) { return; }
    dialog.showModal();
  };
  document.addEventListener('mouseout', event => {
    if (matchMedia('(hover: hover) and (pointer: fine)').matches && !event.relatedTarget && event.clientY <= 0) invite();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
